import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'username'
})

/**
 * UserNamePipe. Gives the Name of the  user logged in and viewing dashboard
 *
 * __Usage :__
 *  ```
 *  <h1>{{ 'userData' | username:'firstName'}}</h1>
 *  userData: user
 *  args='firstName' gives firstName from user Data
 */


export class UserNamePipe implements PipeTransform {

  transform(user: any, args?: any): any {
    let name = '';
    const isFirstName = args === 'firstName';
    if (!user.caregivee && user.careGiver) {
      name = isFirstName ? user.careGiver.firstName : user.careGiver.firstName + ', ' + user.careGiver.lastName;
    } else {
      name = isFirstName ? user.data.firstName : user.data.firstName + ', ' + user.data.lastName;
    }
    return name;
  }
}
